// ErrorBoundary.tsx
import { Component, ErrorInfo } from 'react';
import ErrorComponent from './ErrorComponent';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: undefined,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: _ };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    /* const setErrorBoundary: SetterOrUpdater<{ type?: Error; contents?: ErrorInfo }> =
      useSetRecoilState(errorBoundaryState);
    setErrorBoundary({
      type: error,
      contents: errorInfo,
    }); */
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return <ErrorComponent error={this.state.error} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
